import LoadingButton from './loading_button';

export default LoadingButton;
